import { message } from '@/components/Toast';
import Modal from '@/components/Modal';

// 错误类型定义
export interface ApiError {
  code: number;
  msg: string;
  data?: any;
}

// 错误码枚举
export enum ErrorCode {
  UNAUTHORIZED = 3102,      // 未登录
  NO_PERMISSION = 0,        // 无权限
  LESSON_COMPLETE = 2,      // 课时已完成
  NETWORK_ERROR = -1,       // 网络错误
  SERVER_ERROR = 500,       // 服务器错误
}

// 错误处理器配置
interface ErrorHandlerConfig {
  showNotification?: boolean;
  logToConsole?: boolean;
  reportToServer?: boolean;
}

// 创建错误处理器
export const createErrorHandler = (defaultConfig: ErrorHandlerConfig = {}) => {
  return (
    error: ApiError,
    context: string,
    config: ErrorHandlerConfig = {}
  ) => {
    const finalConfig = { ...defaultConfig, ...config };

    // 1. 打印日志
    if (finalConfig.logToConsole !== false) {
      console.error(`[${context}] Error:`, error);
    }

    // 2. 上报错误（生产环境）
    if (finalConfig.reportToServer && process.env.NODE_ENV === 'production') {
      // TODO: 集成 Sentry 或其他错误监控
      // Sentry.captureException(error, { context });
    }

    // 3. 显示用户友好的错误信息
    if (finalConfig.showNotification !== false) {
      showErrorToUser(error);
    }
  };
};

// 显示用户友好的错误信息
const showErrorToUser = (error: ApiError) => {
  switch (error.code) {
    case ErrorCode.UNAUTHORIZED:
      message.info('请先登录');
      // 可选：跳转到登录页
      // window.location.href = '/enter';
      break;

    case ErrorCode.NO_PERMISSION:
      message.info(error.msg || '无权限，请先购买课程');
      // 可选：显示 VIP 购买弹窗
      // setVipModalShow(true);
      break;

    case ErrorCode.LESSON_COMPLETE:
      message.info('当前课时已完成');
      break;

    case ErrorCode.NETWORK_ERROR:
      message.info('网络错误，请检查网络连接');
      break;

    case ErrorCode.SERVER_ERROR:
      Modal.show({
        title: '服务器错误',
        description: error.msg || '服务暂时不可用，请稍后重试',
        confirmTxt: '确定',
        cancelTxt: '',
      });
      break;

    default:
      message.info(error.msg || '操作失败，请重试');
  }
};
